import React, { FC } from 'react'
import SidePanelFramework from '@bt-react/components/SidePanelFramework'
import { IconType } from '@bt-react/components/Icon'
import SwitchButton from '@bt-react/components/SwitchButton'
import { FeatureFlagsPanelProps } from './types'
import style from './FeatureFlagsPanel.module.scss'
import TwilioDocSupportScreen from '../TwilioDocSupportScreen'

const FeatureFlagsPanel: FC<FeatureFlagsPanelProps> = props => {

  const renderFlags = () => {

    const items: React.JSX.Element[] = []

    for (const [feature, value] of Object.entries(props.featureFlags)) {

      items.push(
        <SwitchButton
          text={feature}
          active={value}
          onClick={() => props.setFeatureFlag(feature, !value)}
          key={`feature-${feature}`}
          className={style['FeatureFlag__button--fill']}
        />
      )

    }

    return items

  }

  return <SidePanelFramework
    icon={IconType.iconName.flag}
    title='Feature Flags'
    dataBdd='side-panel-features'
    content={
      <div>
        {renderFlags()}
        <TwilioDocSupportScreen />
      </div>
    }
  />

}

export default FeatureFlagsPanel
